/* import __COLOCATED_TEMPLATE__ from './delete-glossary-modal.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type GlossaryService from 'embercom/services/glossary-service';

interface Args {
  isOpen: boolean;
  onModalClose: () => void;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class DeleteGlossaryModal extends Component<Signature> {
  @service declare glossaryService: GlossaryService;

  @action
  async deleteGlossary() {
    await this.glossaryService.deleteGlossaries();
    this.args.onModalClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Multilingual::DeleteGlossaryModal': typeof DeleteGlossaryModal;
  }
}
